module.exports = __webpack_public_path__ + "static/media/stock.6486c898.svg";